import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const CONTACT_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID;
const QUOTE_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_QUOTE_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

let initialized = false;

function init() {
  if (!initialized && PUBLIC_KEY) {
    emailjs.init(PUBLIC_KEY);
    initialized = true;
  }
}

export async function sendChatTranscript({ name, email, messages }) {
  init();
  if (!SERVICE_ID || !TEMPLATE_ID) {
    throw new Error("EmailJS not configured. Set REACT_APP_EMAILJS_* variables in .env");
  }

  const transcript = messages
    .map((m) => {
      const time = new Date(m.timestamp).toLocaleString();
      const role = m.sender === "user" ? "Customer" : "Carium Bot";
      return `[${time}] ${role}: ${m.text}`;
    })
    .join("\n\n");

  const templateParams = {
    from_name: name,
    from_email: email,
    transcript,
    timestamp: new Date().toLocaleString(),
    message_count: messages.length,
  };

  return emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams);
}

export async function sendContactForm({ name, email, subject, message }) {
  init();
  if (!SERVICE_ID || !CONTACT_TEMPLATE_ID) {
    throw new Error("EmailJS not configured. Set REACT_APP_EMAILJS_* variables in .env");
  }

  const templateParams = {
    from_name: name,
    from_email: email,
    subject,
    message,
    timestamp: new Date().toLocaleString(),
  };

  return emailjs.send(SERVICE_ID, CONTACT_TEMPLATE_ID, templateParams);
}

export async function sendQuoteEmail({ name, email, service, answers, estimate }) {
  init();
  if (!SERVICE_ID || !QUOTE_TEMPLATE_ID) {
    throw new Error("EmailJS not configured. Set REACT_APP_EMAILJS_* variables in .env");
  }

  const breakdown = estimate.breakdown.join("\n");
  const answerSummary = Object.entries(answers)
    .map(([key, val]) => `${key}: ${val}`)
    .join(", ");

  const templateParams = {
    from_name: name,
    from_email: email,
    service,
    answers: answerSummary,
    estimate_min: estimate.min.toLocaleString(),
    estimate_max: estimate.max.toLocaleString(),
    breakdown,
    period: estimate.period || "",
    timestamp: new Date().toLocaleString(),
  };

  return emailjs.send(SERVICE_ID, QUOTE_TEMPLATE_ID, templateParams);
}
